export default __webpack_public_path__ + "c5f5da296c07eeeaf24c516d408c2492.png";